import Axios from "axios"
import moment from "moment"

const minutesBetweenRequests = 5;

function requestMadeRecently(lastRun) {
    var timeSince = moment().diff(lastRun, 'minutes');
    return timeSince < minutesBetweenRequests;
}

async function getCurrentVersion() {
    let v = await Axios.get(`/app-config.json?t=${new Date().getTime()}`);
    return v.data;
}

const appVersion = {
    lastRun: new Date(),
    version: null,
    async init() {
        let v = await getCurrentVersion();
        this.version = v.lastUpdate;
    },
    async useRefreshToken() {
        let v = await getCurrentVersion();
        return v.useRefreshToken;
    },
    async checkForUpdates() {
        if(requestMadeRecently(this.lastRun)) return false;
        let v = await getCurrentVersion();
        let latest = v.lastUpdate;
        this.lastRun = new Date();

        let updateRequired = this.version != null && this.version != latest;
        this.version = latest;
        return updateRequired;
    }
}

export { appVersion }


// WEBPACK FOOTER //
// ./src/framework/utils/app-version.js